"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressTranslationKey = exports.Progress = exports.UserRoleTranslationKey = exports.UserRole = exports.inputMaxLength = void 0;
exports.inputMaxLength = 50;
var UserRole;
(function (UserRole) {
    UserRole["USER"] = "user";
    UserRole["ADMIN"] = "admin";
    UserRole["MANAGER"] = "manager";
    UserRole["SUPER_ADMIN"] = "superAdmin";
})(UserRole = exports.UserRole || (exports.UserRole = {}));
exports.UserRoleTranslationKey = (_a = {},
    _a[UserRole.USER] = 'Users',
    _a[UserRole.ADMIN] = 'Admins',
    _a[UserRole.MANAGER] = 'Managers',
    _a[UserRole.SUPER_ADMIN] = 'SuperAdmins',
    _a);
var Progress;
(function (Progress) {
    Progress["NOT_STARTED"] = "not_started";
    Progress["STARTED"] = "started";
    Progress["COMPLETED"] = "completed";
})(Progress = exports.Progress || (exports.Progress = {}));
exports.ProgressTranslationKey = (_b = {},
    _b[Progress.NOT_STARTED] = 'NotStarted',
    _b[Progress.STARTED] = 'InProgress',
    _b[Progress.COMPLETED] = 'Completed',
    _b);
